import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
    name: 'user',
    initialState: {
      info: null,
      logged: false,
      currentPod: null,
      podsList: null,
      currentBalance: null,
      currentBalanceEnrica: null,
      datiPagamento: null,
      payMethodDefault: null,
      idContratto: null,
      importo_taglia: null,
      importo_soglia: null,
      nuoviDatiContratto: null,
      notifiche: null,
      totaleConsumi: null,
      totaleOneri: null,
      ultimoSaldo: null,
      totaleSaldo: null,
      idGruppo: null,
      nomePrenotazione3612: null,
      rinnovoContrattuale: null,
    },
    reducers: {
      setRinnovoContrattuale: (state, action) => {
        state.rinnovoContrattuale = action.payload
      },
      setIdGruppo: (state, action) => {
        state.idGruppo = action.payload
      },
      setInfo: (state, action) => {
        state.info = action.payload
      },
      setDataList: (state, action) => {
        state.user = action.payload
      },
      setLoggedIn: (state, action) => {
        state.logged = true
      },
      setLoggedOut: (state, action) => {
        state.logged = false
      },
      setCurrentPod: (state, action) => {
        state.currentPod = action.payload
      },
      setPodsList: (state, action) => {
        state.podsList = action.payload
      },
      setCurrentBalance: (state, action) => {
        state.currentBalance = action.payload
      },
      setCurrentBalanceEnrica: (state, action) => {
        state.currentBalanceEnrica = action.payload
      },
      setExpiryBalanceEnrica: (state, action) => {
        state.expiryBalanceEnrica = action.payload
      },
      setOfferta: (state, action) => {
        state.offerta = action.payload
      },
      setDatiPagamento: (state, action) => {
        state.datiPagamento = action.payload
      },
      setSoglia: (state, action) => {
        state.importo_soglia = action.payload
      },
      setTaglia: (state, action) => {
        state.importo_taglia = action.payload
      },
      setNuoviDatiContratto: ( state, action) => {
        state.nuoviDatiContratto = action.payload
      },
      setNotifiche: (state, action) => {
        state.notifiche = action.payload
      },
      setTotaleConsumi: (state, action) => {
        state.totaleConsumi = action.payload
      },
      setTotaleOneri: (state, action) => {
        state.totaleOneri = action.payload
      },
      setUltimoSaldo: (state, action) => {
        state.ultimoSaldo = action.payload
      },
      setTotaleSaldo: (state, action) => {
        state.totaleSaldo = action.payload
      },
      setPayMethodDefault: (state, action) => {
        state.payMethodDefault = action.payload
      },
      setIdContratto: (state, action) => {
        state.idContratto = action.payload
      },
      setNomePrenotazione: (state, action) => {
        state.nomePrenotazione3612 = action.payload
      },
    },
  });

export const {setRinnovoContrattuale, setNomePrenotazione, setIdContratto, setPayMethodDefault, setIdGruppo, setTotaleSaldo, setUltimoSaldo, setTotaleOneri, setTotaleConsumi, setNotifiche, setNuoviDatiContratto, setSoglia, setTaglia, setDatiPagamento, setOfferta, setInfo, setDataList, setLoggedIn, setLoggedOut, setCurrentPod, setPodsList, setPriceList, setCurrentBalance, setCurrentBalanceEnrica, setExpiryBalanceEnrica} = userSlice.actions;

export default userSlice.reducer;